import React from "react";
import { SceneLayerV3 } from "./scene/SceneLayerV3";
import ThemeSwitcher from "../components/ThemeSwitcher";
import { useVisualEngine } from "./VisualEngineProvider";

export function VisualEngineRoot({ children }) {
  const { themeId, theme } = useVisualEngine();

  return (
    <div className="tl-ve-root">
      <SceneLayerV3 key={themeId} theme={theme} />
      <div className="tl-ve-app">{children}</div>
      <ThemeSwitcher />
    </div>
  );
}
